import { render } from "./AuthCognito.vue?vue&type=template&id=8d59fa70"
import script from "./AuthCognito.vue?vue&type=script&lang=js"
export * from "./AuthCognito.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__